import { render, staticRenderFns } from "./AdminResponsible.vue?vue&type=template&id=522dbfb8&scoped=true"
import script from "./AdminResponsible.vue?vue&type=script&lang=js"
export * from "./AdminResponsible.vue?vue&type=script&lang=js"
import style0 from "./AdminResponsible.vue?vue&type=style&index=0&id=522dbfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522dbfb8",
  null
  
)

export default component.exports